<template>
  <layout>
    <div v-if="maxSmall">
      <div class="flex flex-col">
        <div
          v-if="isPartOfCustomer"
          class="flex flex-col space-y-2 pb-4 pt-6 pl-4 text-xl font-medium text-gray-900 bg-white border-b"
        >
          <h1 class="font-semibold">{{ customers[0].company_name }}</h1>
        </div>

        <div class="flex flex-col gap-1 p-3">
          <PassportNav>
            <PassportNavItem
              variant="building"
              :isGroup="true"
              :label="$t('admin.navigation.buildings.label')"
              @navigate="navigate('settings.organisation.buildings')"
            />
          </PassportNav>
          <PassportNav v-if="hasPermission(permissions.readRecurringTask)">
            <PassportNavItem
              variant="recurring-tasks"
              :label="$t('admin.settings.recurring_tasks.title')"
              @navigate="
                navigate('settings.organisation.recurring-tasks.index')
              "
            />
          </PassportNav>
        </div>
      </div>
    </div>
  </layout>
</template>

<script setup>
import { computed, inject, onBeforeMount } from "vue";
import route from "ziggy-js";
import { usePage, router } from "@inertiajs/vue3";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import Layout from "@/Tailwind/Pages/Settings";
import PersistentLayout from "@/Layouts/PersistentLayout.vue";

import { PassportNav, PassportNavItem } from "@/SharedComponents/Passport";

defineOptions({ layout: PersistentLayout });

const customers = usePage().props.auth.customers;

const { maxSmall } = useBreakpoints();

const { hasPermission, permissions } = inject("permissions");

const isPartOfCustomer = computed(() => {
  if (!customers) {
    return false;
  }

  return customers.length >= 1;
});

onBeforeMount(() => {
  if (!maxSmall.value) {
    router.visit(route("settings.organisation.buildings"));
  }
});

const navigate = (url) => {
  router.visit(route(url), {
    preserveScroll: true,
    preserveState: true,
  });
};
</script>
